// schedule a function to run after next paint
// https://web.dev/articles/optimize-long-tasks
export const yieldToMain = (fn: () => unknown) => {
  window.requestAnimationFrame(() => {
    window.setTimeout(fn, 0);
  });
};
